export const DashboardPage = () => {
    return (
        <h1>Dashboard Page</h1>
    )
}
